import React from 'react';
import { initSentry } from '@anyroad/sentry';
import { wrapAllComponents } from 'lib/withIntl';

window.React = React;
window.ReactDOM = require('react-dom');

initSentry({ application: 'affiliate_portal' });

const AffiliatePortal = require('views/affiliate_portal').default;

window.Views = wrapAllComponents({
  Anyguide: {
    AffiliatePortal,
  },
});
